export const products = [
  {
    id: "sku01",
    //type: "KS",
    name: "海藻 海泥 シャンプー",
    img: "/assets/image/products/item-st/img_product_01.png",
    caption:
      "ダメージをケアしながら汚れをすっきり落とし、しっとりまとまる髪へ",
    link: "/products/series-damage/#arc-product-ks",
    label: ""
  },
  {
    id: "sku02",
    //type: "KT",
    name: "海藻 海泥 トリートメント",
    img: "/assets/image/products/item-st/img_product_04.png",
    caption: "髪の内部から補修し、毛先まで潤いに満ちた、しっとりまとまる髪へ",
    link: "/products/series-damage/#arc-product-kt",
    label: ""
  },
  {
    id: "sku03",
    //type: "KM",
    name: "海藻 海泥 ヘア マスク",
    img: "/assets/image/products/item-st/img_product_07.png",
    caption:
      "髪の内部まで浸透し、留まって集中補修するスペシャルケア。潤ってまとまる美髪へ",
    link: "/products/series-damage/#arc-product-km",
    label: ""
  },
  {
    id: "sku04",
    //type: "HE",
    name: "海藻 ヘア エッセンス しっとり",
    img: "/assets/image/products/item-nightoutbath/img_product_01.png",
    caption:
      "濃密なエッセンスで髪ダメージをじっくり補修。しっとりまとまるツヤやかな髪へ",
    link: "/products/series-damage/#arc-product-he",
    label: ""
  },
  {
    id: "sku05",
    //type: "SHE",
    name: "海藻 ヘア エッセンス さらさら",
    img: "/assets/image/products/item-nightoutbath/img_product_02.png",
    caption:
      "濃密なエッセンスで髪ダメージをじっくり補修。さらさら軽やかでツヤやかな髪へ",
    link: "/products/series-damage/#arc-product-she",
    label: ""
  },
  {
    id: "sku06",
    //type: "HEH",
    name: "海藻 ヘア エッセンス ヒートメモリー",
    img: "/assets/image/products/item-nightoutbath/img_product_03.png",
    caption:
      "ストレートでもカールでも。ダメージを補修しながら、翌日のスタイルを長時間キープ",
    link: "/products/series-damage/#arc-product-heh",
    label: ""
  },
  {
    id: "sku07",
    //type: "SHS",
    name: "海藻 シルキー ヘア スプレー",
    img: "/assets/image/products/item-morningoutbath/img_product_01.png",
    caption:
      "痛んだキューティクルを補修し、シルクのようになめらかで、つるつるサラサラの髪へ",
    link: "/products/series-damage/#arc-product-shs",
    label: ""
  },
  {
    id: "sku08",
    //type: "HMTM",
    name: "海藻 ヘア セラム ミスト",
    img: "/assets/image/products/item-morningoutbath/img_product_02.png",
    caption:
      "ごわつき原因の蓄積や日中のダメージをケアして守る、うるおい補給美容液。",
    link: "/products/series-damage/#arc-product-hmtm",
    label: ""
  },
  {
    id: "sku09",
    //type: "HMKS",
    name: "海藻 ヘア セラム ミルク",
    img: "/assets/image/products/item-morningoutbath/img_product_03.png",
    caption:
      "つやめき素髪感をつくるスタイリング美容液。コテアイロン前に仕込んでスタイルキープも。",
    link: "/products/series-damage/#arc-product-hmks",
    label: ""
  },
  {
    id: "sku10",
    //type: "VHE",
    name: "海藻 ボリュームアップ ヘア エッセンス",
    img: "/assets/image/products/item-nightoutbath/img_product_04.png",
    caption:
      "髪の根元からダメージを補修し、ふんわりボリュームのあるハリ・コシ・艶髪へ",
    link: "/products/series-harikoshi/#arc-product-vhe",
    label: ""
  },
  {
    id: "sku11",
    //type: "VMT",
    name: "海藻 ボリュームアップ ヘア ミスト",
    img: "/assets/image/products/item-morningoutbath/img_product_04.png",
    caption:
      "シュッとひと吹き、手ぐしでドライヤーするだけで、根元から自然なふんわり髪へ",
    link: "/products/series-harikoshi/#arc-product-vmt",
    label: ""
  },
  {
    id: "sku12",
    //type: "PS",
    name: "プレミオール シャンプー",
    img: "/assets/image/products/item-st/img_product_03.png",
    caption:
      "慢性的なダメージをケアしながら、 しっとりまとまりのある、なめらかな髪へ",
    link: "/products/series-premior/",
    label: ""
  },
  {
    id: "sku13",
    //type: "PT",
    name: "プレミオール トリートメント",
    img: "/assets/image/products/item-st/img_product_06.png",
    caption: "髪の奥深くまで浸透補修。しっとりなめらかで、内部からしなやかな髪へ",
    link: "/products/series-premior/",
    label: ""
  },
  {
    id: "sku14",
    //type: "PHE",
    name: "プレミオール ヘア エッセンス",
    img: "/assets/image/products/item-nightoutbath/img_product_05.png",
    caption:
      "慢性的なダメージを濃密補修。艶を与え、しっとりしなやかで、なめらかな髪へ",
    link: "/products/series-premior/",
    label: ""
  },
  {
    id: "sku15",
    //type: "YKJ",
    name: "薬用 地肌 ジェル",
    img: "/assets/image/products/item-restorer/img_product_01.png",
    caption: "頭皮に直接ぬれて垂れにくいジェルタイプ。脱毛を予防し発毛を促進",
    link: "/products/series-harikoshi/#arc-product-ykj",
    label: "医薬部外品"
  },
  {
    id: "sku16",
    //type: "YKL",
    name: "薬用 地肌 ローション",
    img: "/assets/image/products/item-restorer/img_product_02.png",
    caption: "頭皮にサッと広がるローションタイプ。脱毛を予防し発毛を促進",
    link: "/products/series-harikoshi/#arc-product-ykl",
    label: "医薬部外品"
  },
  {
    id: "sku17",
    //type: "HC",
    name: "ヘアカラー",
    img: "/assets/image/products/item-dyeing/img_product_01.png",
    caption:
      "髪と頭皮をいたわりながら自然な風合いに染める、ムースタイプの白髪染め",
    link: "/products/series-color/#arc-product-hc",
    label: "医薬部外品"
  },
  {
    id: "sku18",
    //type: "HCS",
    name: "ヘアカラー スティック",
    img: "/assets/image/products/item-dyeing/img_product_03.png",
    caption:
      "お出かけ前、気になる白髪にサッと塗るだけの、ブラシタイプの簡単白髪かくし",
    link: "/products/series-color/#arc-product-hcs",
    label: ""
  },
  {
    id: "sku19",
    //type: "HCT",
    name: "ヘアカラー トリートメント",
    img: " /assets/image/products/item-dyeing/img_product_02.png",
    caption:
      "美髪ケアしながら徐々に染まる。いつものトリートメントに置き換えて使う白髪染め。",
    link: "/products/series-color/#arc-product-hct",
    label: ""
  },
  {
    id: "sku20",
    //type: "YKS",
    name: "薬用 シャンプー",
    img: "/assets/image/products/item-st/img_product_02.png",
    caption: "頭皮環境を健やかに整えながらやさしく洗い、芯からコシのある髪へ",
    link: "/products/series-harikoshi/#arc-product-yks",
    label: "医薬部外品"
  },
  {
    id: "sku21",
    //type: "YKT",
    name: "薬用 トリートメント",
    img: "/assets/image/products/item-st/img_product_05.png",
    caption: "やせた髪を補修し、ピンとしたハリと艶を持つ、ふんわり髪へ",
    link: "/products/series-harikoshi/#arc-product-ykt",
    label: "医薬部外品"
  },
];
